<template>
    <div v-if="!isMobile" class="tendancesBox">
        <div class="router">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">{{ 'Femme' }}</el-breadcrumb-item>
                <el-breadcrumb-item> {{ 'tendances' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <h3 class="title">{{ 'Tendances' }}</h3>
        <div class="picListBox1">
            <div class="pic" v-for="item of list.threeOfLine"
                 :key="item.id_tendance" @click="jumpProdList(item)">
                <FillBgBox class="fillBg" :bg-img="item.file.file_url">
                    <h3>{{ item.tendances_langues[0].libelle }}</h3>
                    <p>{{ langPage['sidemenu']['TXT_decouvrir'] }}</p>
                </FillBgBox>
            </div>
        </div>
        <div class="pic2" v-for="item of list.oneOfLine"
             :key="item.id_tendance" @click="jumpProdList(item)">
            <FillBgBox class="fillBg" :bg-img="item.file.file_url">
                <h3>{{ item.tendances_langues[0].libelle }}</h3>
                <p>{{ langPage['sidemenu']['TXT_decouvrir'] }}</p>
            </FillBgBox>
        </div>
        <div class="picListBox1">
            <div class="pic3" v-for="item of list.twoOfLine"
                 :key="item.id_tendance" @click="jumpProdList(item)">
                <FillBgBox class="fillBg" :bg-img="item.file.file_url">
                    <h3>{{ item.tendances_langues[0].libelle }}</h3>
                    <p>{{ langPage['sidemenu']['TXT_decouvrir'] }}</p>
                </FillBgBox>
            </div>
        </div>
        <div style="margin-top: 8.3vw">
            <el-divider/>
        </div>
    </div>
    <div v-else class="mtendancesBox mobileCommon">
        <h3 class="title">{{ 'Tendances' }}</h3>
        <div class="picListBox1">
            <FillBgBox class="pic fillBg"
                       v-for="(item,index) of
                      ([].concat(list.threeOfLine).concat(list.oneOfLine).concat(list.twoOfLine))"
                       :key="index"
                       :bg-img="item.file.file_url"
                       @click="jumpProdList(item)">
                <h3>{{ item.tendances_langues[0].libelle }}</h3>
                <p>{{ langPage['sidemenu']['TXT_decouvrir'] }}</p>
            </FillBgBox>
        </div>
        <div style="margin-top: 15vw">
            <el-divider/>
        </div>
    </div>
</template>

<script>
import BottomNav from "@/components/bottomNav";
import base from "@/api/base";
import FillBgBox from "@/components/fillBgBox";

let moment = require('moment');

export default {
    name: "Tendances",
    components: {FillBgBox, BottomNav},
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            langPage: this.$store.state.langPage,
            client_imgs: this.$store.state.client_page_imgs.tendances,
            picList: {
                pic1: require('@/assets/img/tendances/pic1.jpg'),
                pic2: require('@/assets/img/tendances/pic2.jpg'),
                pic3: require('@/assets/img/tendances/pic3.jpg'),
                pic4: require('@/assets/img/tendances/pic4.jpg'),
                pic5: require('@/assets/img/tendances/pic5.jpg'),
                pic6: require('@/assets/img/tendances/pic6.jpg'),
            },
            mpicList: {
                mpic1: require('@/assets/img/tendances/mpic1.jpg'),
                mpic2: require('@/assets/img/tendances/mpic2.jpg'),
                mpic3: require('@/assets/img/tendances/mpic3.jpg'),
                mpic4: require('@/assets/img/tendances/mpic4.jpg'),
                mpic5: require('@/assets/img/tendances/mpic5.jpg'),
                mpic6: require('@/assets/img/tendances/mpic6.jpg'),
            },
            list: {},
            tempList: {},
        }
    },
    mounted() {
        // this.replaceClientImgs();
        this.getTendances();
    },
    methods: {
        async getTendances() {
            let res = await this.$api.good.get_tendances();
            if (res.code != 0) return;
            this.tempList = res.data;
            console.log('list', this.list, this.tempList)
            let temp = {oneOfLine: [], twoOfLine: [], threeOfLine: []};
            for (let item of this.tempList) {
                let file_url = '';
                if (item.file) {
                    file_url = base.dev + item.file.file_url;
                    console.log('list1', file_url)
                    let size = await this.getImgFileInfo(file_url);
                    item.file.file_url = file_url;
                    console.log('list2', size)
                    if (size.width == '2624' && size.height == '1000') {
                        temp.oneOfLine.push(item);
                    } else if (size.width == '1280' && size.height == '1000') {
                        temp.twoOfLine.push(item);
                    } else if (size.width == '832' && size.height == '1000') {
                        temp.threeOfLine.push(item);
                    }
                } else {
                    item.file = {file_url};
                    temp.threeOfLine.push(item);
                }
            }
            this.list = temp;
            console.log('list3', this.list, temp)
            this.$forceUpdate();
            // this.list.contact(temp.threeOfLine)
            //     .contact(temp.oneOfLine)
            //     .contact(temp.twoOfLine);
        },
        //替换客户端图片
        replaceClientImgs() {
            let clientImgs = this.client_imgs;
            if (!clientImgs.pic1) return;
            for (let key of Object.keys(this.picList)) {
                this.picList[key] = clientImgs[key].file_url;
            }
            for (let key of Object.keys(this.mpicList)) {
                this.mpicList[key] = clientImgs[key].file_url;
            }
            this.$forceUpdate();
        },
        async getImgFileInfo(fileUrl) {
            return new Promise(resolve => {
                let img = new Image();
                let item = {};
                item.width = 0;
                item.height = 0;
                let _URL = window.URL || window.webkitURL;
                img.onload = function () {
                    item.width = this.width;
                    item.height = this.height;
                    resolve(item);
                }
                img.src = fileUrl;
            })
        },
        jumpProdList(item) {
            this.$router.push(`productList?tendances=${item.id_tendance}`);
        }
    }
}
</script>

<style lang="less" scoped src="@/assets/viewCss/views/Tendances.less">
</style>
